import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 商材一覧
export async function getProductOptions(id: string) {
  try {
    const path = "productOptions";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 商材（オプション）編集
export async function putProductOptions(editData: { [key: string]: any }) {
  try {
    const path = "productOptions";
    const bodys = editData;
    const response = await axios.put(CONST.apiUrl + path, {
      bodys,
    });
    return { edit: response.data.edit, warning: response.data.warning || "" };
  } catch (error) {
    // logout();
  }
}

// エントリーフォーム詳細（メインテーブル）取得
export async function getProductOption(id: string) {
  try {
    const path = "productOption";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string;
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: number | string;
    }[] = response.data.option_data;
    return { detail_data, option_data };
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 質問一覧編集時の依存サービス定義用サービス一覧取得
export async function getProductOptionsDependServices(product_id: string) {
  try {
    const path = "productOptions/depend/services";
    const params = { product_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const service_plan_data: {
      service_plan_id: number;
      service_plan_name: string;
    }[] = response.data.service_plan_data;
    const service_content_data: {
      service_content_id: number;
      service_content_name: string;
    }[] = response.data.service_content_data;
    const fetch_product_key: string = response.data.product_key;
    const fetch_product_contract_number: string =
      response.data.product_contract_number ?? "0";
    return {
      service_plan_data,
      service_content_data,
      fetch_product_key,
      fetch_product_contract_number,
    };
  } catch (error) {
    // logout();
    return {
      service_plan_data: [],
      service_content_data: [],
      fetch_product_key: "0",
      fetch_product_contract_number: "0",
    };
  }
}
